import { useState, useEffect } from "react";
import { TextField } from "@mui/material";

const formatZipCode = (value) => {
    return value.replace(/\D/g, "").slice(0, 8) // Remove não numéricos e limita a 8 dígitos
        .replace(/^(\d{5})(\d)/, "$1-$2"); // Aplica o formato 81670-130
};

const ZipCodeInput = ({ zipCode, setZipCode, setAddress, setNeighborhood, setCity, setState, disabled = false }) => {
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const formattedZip = formatZipCode(e.target.value);
        setZipCode(formattedZip);
    };

    useEffect(() => {
        if (disabled) {
            return;
        }
        const fetchAddress = async () => {
            if (zipCode.length === 9) { // Só busca quando o CEP está completo
                setLoading(true);
                try {
                    const response = await fetch(`https://viacep.com.br/ws/${zipCode.replace("-", "")}/json/`);
                    const data = await response.json();

                    if (!data.erro) {
                        setAddress(data.logradouro || "");
                        setNeighborhood(data.bairro || "");
                        setCity(data.localidade || "");
                        setState(data.uf || "");
                    }
                } catch (error) {
                    console.error("Erro ao buscar endereço:", error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchAddress();
    }, [zipCode, disabled]);

    return (
        <TextField
            label={loading ? "Buscando..." : "CEP"}
            fullWidth
            value={zipCode}
            onChange={handleChange}
            inputMode="numeric"
            disabled={disabled || loading}
        />
    );
};

export default ZipCodeInput;
